export function mapInvestmentsError(code: string): string {
  switch (code) {
    case "HAS_QUOTES":
      return "investments.errors.has_quotes";
    case "INVALID_ACCOUNT":
      return "investments.errors.invalid_account";
    case "PROVIDER_UNAVAILABLE":
      return "investments.errors.provider_unavailable";
    case "QUOTA_EXCEEDED":
      return "investments.errors.quota_exceeded";
    case "SYMBOL_NOT_FOUND":
      return "investments.errors.symbol_not_found";
    case "NO_PROVIDER_FOR_KIND":
      return "investments.errors.no_provider_for_kind";
    case "VALIDATION_ERROR":
      return "investments.errors.validation";
    case "NOT_FOUND":
      return "investments.errors.not_found";
    case "AUTHENTICATION_ERROR":
      return "errors.unauthenticated";
    default:
      return "errors.unknown";
  }
}
